<template>
  <article>

    <h1 class="text-center m-5">EVENTS</h1>
    <div style="position: relative;">
      <!-- Loading overlay -->
      <v-overlay v-model="loading" contained class="align-center justify-center" scrim="transparent" persistent>
        <v-progress-circular color="amber" indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="d-flex flex-wrap justify-content-center mx-2">
        <EventCard :event="event" v-for="event in events" :key="event.id" />
      </div>
    </div>
  </article>
</template>

<script>
import { collection, onSnapshot, query, orderBy, where, updateDoc } from "firebase/firestore";
import { db } from "@/firebase"
import EventCard from '@/components/EventCard.vue'
import { onBeforeMount, onMounted, ref, onUnmounted } from 'vue'
import { useStore } from 'vuex'

export default {
  components: {
    EventCard,
  },
  setup() {

    const events = ref([]);
    let unsubscribe;

    // Overlay handling
    const loading = ref(false);

    onBeforeMount(async () => {
      // Use store to fetch empty image when image upload somehow fails
      await useStore().dispatch('events/fetchEmptyImage')
    })

    onMounted(() => {

      // Show loading overlay
      loading.value = true;

      const eventsCollection = collection(db, 'Events');
      const q = query(eventsCollection, where("IsArchived", "==", false), orderBy('CreationTimestamp', "asc"));
      unsubscribe = onSnapshot(q, (snapshot) => {
        events.value = snapshot.docs.map((doc) => {
          const data = doc.data();

          // If the event has no host, close the event (put to volunteer opportunities) and set the MainHostName to empty
          if (data.MainHost == "") {
            updateDoc(doc.ref, {
              IsOpen: false,
              MainHostName: "",
            });
          }
          return { id: doc.id, ...doc.data() }
        })

        // Show loading overlay
        loading.value = false;
      });
    });

    onUnmounted(() => {
      unsubscribe();
    });

    return { events, loading }

  },
}
</script>

<style scoped src="@/assets/css/admin.css"></style>